export function sanitizeExhibitorsFilter(filter, availableTags) {
    return {
        favorites: !!filter?.favorites,
        text: filter?.text?.toString() ?? '',
        tags: availableTags.reduce((tags, tag) => {
            const sanitizedOptions = tag.options.filter(option => filter?.tags?.[tag.name]?.includes(option.name));
            if (sanitizedOptions.length) {
                tags[tag.name] = sanitizedOptions.map(option => option.name);
            }
            return tags;
        }, {}),
    };
}
